import React from 'react';

// Shared Components
import styles from './TableLabel.scss';

export default function TableLabel({ children = 'No Name', disabled }) {
  const disabledClassName = disabled ? styles.disabled : '';
  return (
    <div className={`${styles.tableLabel} ${disabledClassName}`}>
      <div className={styles.tableLabelText}>{children}</div>
    </div>
  );
}
